import {createContext, useContext, useState, useCallback} from "react";
import instance from "../api/axios";

const CartContext = createContext(undefined, undefined);
export const useCart = () => useContext(CartContext);

let url = process.env.REACT_APP_BASE_URL;

export const CartProvider = ({children}) => {
    const [cart, setCart] = useState(null);

    const refreshCart = useCallback(async () => {
        try {
            const response = await instance.get(`${url}/abio/public/cart/getCart`);
            setCart(response.data);
            return response.data;
        } catch (e) {
            console.log("getCart error:", e);
        }
    }, []);

    const addProduct = async (productCode, quantity = 1) => {
        try {
            const response = await instance.post(
                `${url}/abio/public/cart/addProduct`,
                {},
                {
                    params: {
                        productCode,
                        quantity
                    }
                }
            );

            // 🔥 Google Tag Manager event
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ecommerce: null});
            window.dataLayer.push({
                event: "add to cart",
                ecommerce: {
                    items: response.data.cartProductDTOList.map((product, index) => ({
                        item_name: product.name_en,
                        item_id: product.productCode,
                        price: product.price,
                        item_list_name: "cart",
                        index: index + 1,
                        quantity: product.quantity
                    }))
                }
            });

            setCart(response.data);
            return response.data;

        } catch (error) {
            console.error("addProduct error:", error);
        }
    };

    const decreaseProduct = async (productCode) => {
        try {
            const response = await instance.post(
                `${url}/abio/public/cart/decreaseProduct`,
                {},
                {
                    params: {
                        productCode,
                    }
                }
            );

            // 🔥 Google Tag Manager event
            // window.dataLayer = window.dataLayer || [];
            // window.dataLayer.push({ecommerce: null});
            // window.dataLayer.push({
            //     event: "remove from cart",
            //     ecommerce: {
            //         items: response.data.cartProductDTOList.map((product, index) => ({
            //             item_name: product.name_en,
            //             item_id: product.productCode,
            //             price: product.price,
            //             item_list_name: "cart",
            //             index: index + 1,
            //             quantity: product.quantity
            //         }))
            //     }
            // });

            setCart(response.data);
            return response.data;

        } catch (error) {
            console.error("decreaseProduct error:", error);
        }
    };

    const deleteProduct = async (productCode) => {
        try {
            const response = await instance.post(
                `${url}/abio/public/cart/deleteProduct`,
                {},
                {
                    params: { productCode }
                }
            );

            // OPTIONAL: GTM event
            // window.dataLayer = window.dataLayer || [];
            // window.dataLayer.push({ ecommerce: null });
            // window.dataLayer.push({
            //     event: "remove from cart",
            //     ecommerce: {
            //         items: [{
            //             item_id: productCode,
            //             quantity: 1
            //         }]
            //     }
            // });

            setCart(response.data);
            return response.data;

        } catch (error) {
            console.log("deleteProduct error:", error);
        }
    };


    const removePromocode = async (promoCode, xsrfToken) => {
        try {
            const response = await instance.post(
                `${url}/abio/public/cart/removePromocode`,
                {},
                {
                    headers: {
                        "X_ORDER_XSRF_TOKEN": xsrfToken,
                    },
                    params: {
                        promoCode,
                    },
                }
            );

            setCart(response.data);
            return response.data;
        } catch (error) {
            console.log("removePromocode error:", error);
        }
    };

    const applyPromocode = async (promoCode, xsrfToken) => {
        try {
            const response = await instance.post(
                `${url}/abio/public/cart/applyPromocode?promoCode=${promoCode}`,
                {},
                {
                    headers: {
                        "X_ORDER_XSRF_TOKEN": xsrfToken,
                    },
                }
            );

            setCart(response.data);

            return { success: true, data: response.data };

        } catch (e) {
            console.log("applyPromocode error:", e);

            const resp = (e?.response?.data?.message || "").toString().toLowerCase();

            // Detect invalid promo code from ANY backend message
            const isInvalid =
                resp.includes("invalid promo") ||
                resp.includes("invalid promo-code") ||
                resp.includes("promcode with code") ||
                resp.includes("promocode with code") ||
                resp.includes("with code") && resp.includes("not found");

            if (isInvalid) {
                return { success: false, error: "INVALID_PROMO" };
            }

            return { success: false, error: "TECHNICAL" };
        }

    };

    const setDeliveryRegion = async (regionId) => {
        const response = await instance.post(`${url}/abio/public/cart/addDeliveryRegion`, {}, {
            params: {deliveryRegionId: regionId}
        });

        setCart(response.data);
        return response.data;
    };

    const setDeliveryByDistance = async ({address, distanceMeters, yerevan}) => {
        const response = await instance.post(`${url}/abio/public/cart/setDeliveryByDistance`, {}, {
            params: {address, distanceMeters, yerevan}
        });

        setCart(response.data);
        return response.data;
    };

    const value = {
        cart,
        refreshCart,
        addProduct,
        decreaseProduct,
        deleteProduct,
        removePromocode,
        applyPromocode,
        setDeliveryRegion,
        setDeliveryByDistance
    };

    return (
        <CartContext.Provider value={value}>
            {children}
        </CartContext.Provider>
    );
};
